/* global axios */
import ApiClient from './ApiClient';

class WhatsappOutgoingApi extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  sendOrderDetails(conversationId, payload) {
    return axios.post(
      `${this.url}/${conversationId}/whatsapp/order_details`,
      payload
    );
  }

  sendLocationRequest(conversationId, payload) {
    return axios.post(
      `${this.url}/${conversationId}/whatsapp/location_request`,
      payload
    );
  }

  sendReaction(conversationId, payload) {
    return axios.post(
      `${this.url}/${conversationId}/whatsapp/reaction`,
      payload
    );
  }
}

export default new WhatsappOutgoingApi();
